import { Box, Toolbar } from '@mui/material';
import { type ReactNode } from 'react';
import { useStatusBarHeight } from './safe';

export default function Content({ children }: { children: ReactNode }) {
  const statusBarHeight = useStatusBarHeight();

  return (
    <>
      <Box sx={{ paddingTop: statusBarHeight }}>
        <Toolbar />
      </Box>
      {children}
    </>
  );
}
